<template>
  <div class="d-flex justify-space-between" @click="onClickName">{{ valueToDraw }}</div>
</template>

<script>

import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { EventBus } from '../helpers/eventBus';

// First column, the product name
@Component
export default class ProductCell extends Vue {
  @Prop({ type: String, required: true, default: null }) prop;

  @Prop({ type: Object, required: true, default: null }) model;

  get valueToDraw() {
    return this.model[this.prop];
  }

  onClickName() {
    EventBus.$emit('product', this.model.productGuid, this.model.productName);
  }
}

</script>
